module.exports = __webpack_public_path__ + "static/media/door-open.6760519b.svg";